import { render } from "./Gamburger.vue?vue&type=template&id=43518fea"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Gamburger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43518fea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43518fea', __exports__)) {
    api.reload('43518fea', __exports__)
  }
  
  module.hot.accept("./Gamburger.vue?vue&type=template&id=43518fea", () => {
    api.rerender('43518fea', render)
  })

}


export default __exports__